// extracted by mini-css-extract-plugin
export var main = "page-module--main--9+vVc";